<template>
  <div class="page">
    <div class="cont" style="padding-top:0.7rem;">
      <!-- <div class="header_flex">
        <div class="header_flex_left">
          <img class="imgx" :src="user.avatar?user.avatar:img2" alt />
          <p class="header_flex_left_p">{{ user.nickName }}</p>
          <span class="vip" v-if="obj.grade">{{ obj.grade }}</span>
        </div>
        <div class="header_flex_right">
          <img class="button" id="guizeFn" @click="guizeFn()" src="../img/shi1.png" alt />
          <img class="button" id="lianxi" @click="lianxi()" src="../img/shi2.png" alt />
        </div>
      </div>

      <div class="jifen_cont">
        <div class="jifen_cont_top">
          <h3>{{ obj.totalAmount }}</h3>
          <p>累计积分(包含待到账)</p>
        </div>
        <div class="jifen_cont_botton">
          <div>
            <h3>{{ obj.todayAmount }}</h3>
            <p>今日积分</p>
          </div>

          <div @click="jifen('/points?active=0','1')" id="preAmount">
            <h3>{{ obj.preAmount }}</h3>
            <p class="dis">
              待到账积分
              <img v-if="this.$store.state.data.state == 'wx'" src="../img/right.png" alt />
            </p>
          </div>

          <div @click="jifen('/points','2')" id="memberAmount">
            <h3>{{ obj.memberAmount }}</h3>
            <p class="dis">
              可用积分
              <img v-if="this.$store.state.data.state == 'wx'" src="../img/right.png" alt />
            </p>
          </div>
        </div>
      </div> -->
      <div class="user">
        <div class="line1">
          <div class="avatar"><img :src="user.avatar?user.avatar:img2"></div>
          <div class="name">{{ user.nickName | ellipsis}}</div>
          <div class="vip" v-if="user.isAgent == '1'">{{ obj.grade }}</div>
        </div>
        <div class="line2">
          <div class="totalAmount">{{ obj.preAmount }}</div>
          <div style="color:#666666">累计积分 (含待到账)</div>
        </div>
        <div class="line3">
          <van-row type="flex" justify="center" style="text-align:center;">
            <van-col span="7" style="border-right:1px solid #eee;">
              <div class="num">{{ obj.todayAmount }}</div>
              <div class="text">今日积分</div>
            </van-col>
            <van-col span="9" style="border-right:1px solid #eee;" @click="jifen('/points?active=0','1')">
              <div class="num">{{ obj.preAmount }}</div>
              <div class="text dis">&nbsp;&nbsp;&nbsp;待到账积分
              <img v-if="this.$store.state.data.state == 'wx'" src="../img/right.png" alt />
              </div>
            </van-col>
            <van-col span="8" @click="jifen('/points','2')">
              <div class="num">{{ obj.memberAmount }}</div>
              <div class="text dis">&nbsp;&nbsp;&nbsp;可用积分
              <img v-if="this.$store.state.data.state == 'wx'" src="../img/right.png" alt />
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
      <div class="fun">
        <van-row type="flex" justify="center" style="text-align:center;">
            <van-col span="8" id="kanjiajilu" @click="log()" v-if="this.channelType !='assistant'">
              <div class="fun_ico"><img src="../img/ico1.png" alt=""></div>
              <div class="text">砍价记录</div>
            </van-col>
            <van-col :span="this.channelType =='assistant'?'12':'8'" @click="guizeFn()">
              <div class="fun_ico"><img src="../img/ico2.png" alt=""></div>
              <div class="text">晋升规则</div>
            </van-col>
            <van-col :span="this.channelType =='assistant'?'12':'8'" @click="lianxi()">
              <div class="fun_ico"><img src="../img/ico3.png" alt=""></div>
              <div class="text">联系助手</div>
            </van-col>
          </van-row>
      </div>
      <div>
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="(item,i)  in listObj" @click="urlFn(item.jumpUrl)" :key="i">
            <img class="img1" :src="item.picUrl" style="width: 100%;display: block" alt />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="tab">
        <div class="tabDiv">
          <div class="tabs">
            <div class="tab_list">
              <p class="tab_color">热门商品</p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="items.length > 0">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :immediate-check="check"
          @load="onLoad"
        >
          <div class="contx">
            <div
              class="list"
              v-for="(item,i)  in items"
              :key="i"
              @click="jumpUrl(item,i)"
              :id="'product_list'+i"
            >
              <img class="good_list" :src="item.picUrl?item.picUrl:img" alt />
              <div class="goods_text_cont_x">
                <p class="goods_text_p">{{ item.goodsName }}</p>
                <div class="goods_text_cont">
                  <p class="goods_text goods_text_left">
                    ¥
                    <span>{{ item.price}}</span>
                  </p>
                  <p class="goods_text goods_text_right" v-if="user.isAgent == '1'">
                    <span>+{{item.integral}}</span
                    >&nbsp;<img
                      class="good_list_img"
                      src="../img/jifen.png"
                      alt
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>

      <div class="kong1" v-if="items.length == 0">
        <img src="../img/kong1.png" alt />
        <p>暂无商品</p>
      </div>
    </div>
    <footer-body></footer-body>
  </div>
</template>

<script>
import footerBody from "../../common/footer/footer";
import getWXSign from "@/libs/wxSign";
import config from "@/libs/config";

export default {
  name: "profitHome",
  data() {
    return {
      items: [],
      q: {
        type: "2",
        page: "1",
        limit: "10",
        sort: "2"
      },
      loading: false,
      finished: false,
      listObj: [],
      check: false,
      user: "",
      obj: {},
      img: require("../img/timg-21@2x.png"),
      img2: require("../img/header.png"),
      channelType:""
    };
  },
  computed: {},
  components: {
    footerBody
  },
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value&&value.length > 8) {
        return value.slice(0, 8)+ "...";
      }
      return value;
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.goods();
    this.list();
    this.profitCenter();
    this.$nextTick(() => {
      this.$trackFn.load("kanjiajilu", "view_material", {
        page_type: "profit",
        card_type: "bargain",
        sell_type:"retailstore",
                  sell_label:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'goodsid_yljkapp_yygw':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'goodsid_ydbapp_sy':"goodsid_wx_off",
                  sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
        material_type:"bargain",
        material_link:`${window.location.origin}/log`
      });
    });
     this.channelType = JSON.parse(sessionStorage.getItem("user")).channelType;
    if(this.channelType == 'app') UnionDrugHealthy.hiddenShareIcon()
  },
  methods: {
    jifen(url, state) {
      if (this.$store.state.data.state == "ydb") {
        return;
      }
      switch (state) {
        case "1":
          this.$trackFn.send("click_material", {
            // 点击 - 埋点
            page_type: "profit",
            card_type: "my_points",
            card_position: 1,
            material_type: "to_issue",
            material_position: 1,
            material_link: config.config().wx + url
          });
          break;
        case "2":
          this.$trackFn.send("click_material", {
            // 点击 - 埋点
            page_type: "profit",
            card_type: "my_points",
            card_position: 1,
            material_type: "issued",
            material_position: 1,
            material_link: config.config().wx + url
          });
          break;

        default:
          break;
      }
      window.location.href = config.config().wx + url;
    },
    jumpUrl(item, i) {
      this.$trackFn.send("click_material", {
        // 点击 - 埋点
        page_type: "profit",
        card_type: "product_list",
        card_position: i + 1,
        material_id: item.skuNo,
        material_type: "product_id",
        material_link: item.goodsDetailUrl,
        material_position: i + 1
      });
      window.location.href = item.goodsDetailUrl;
    },
    profitCenter() {
      this.$api.show({}).then(res => {
        this.obj = res.data;
        this.$nextTick(() => {
          this.$trackFn.load("guizeFn", "view_material", {
            // 曝光 - 埋点
            page_type: "profit",
            card_type: "promotion_rule",
            card_position: 1,
            material_type: "promotion_rule",
            material_position: 1,
            material_link:
              window.location.protocol +
              "//" +
              window.location.host +
              "/distribution/guize"
          });
          this.$trackFn.load("lianxi", "view_material", {
            // 曝光 - 埋点
            page_type: "profit",
            card_type: "contact_service",
            card_position: 1,
            material_type: "contact_service",
            material_position: 1,
            material_link:
              window.location.protocol +
              "//" +
              window.location.host +
              "/distribution/call"
          });
          this.$trackFn.load("preAmount", "view_material", {
            // 曝光 - 埋点
            page_type: "profit",
            card_type: "my_points",
            card_position: 1,
            material_type: "to_issue",
            material_position: 1,
            material_link: config.config().wx + "/points?active=0"
          });
          this.$trackFn.load("memberAmount", "view_material", {
            // 曝光 - 埋点
            page_type: "profit",
            card_type: "my_points",
            card_position: 1,
            material_type: "issued",
            material_position: 1,
            material_link: config.config().wx + "/points"
          });
        });

        let time1 = new Date().getTime();
        window.onbeforeunload = e => {
          let time2 = new Date().getTime();
          let dateDiff = (time2 - time1) / 1000;
          let page_type = "profit";
          this.$trackFn.view("$pageview", {
            page_type: page_type,
            event_duration: dateDiff
          }); // 商品列表页 ——浏览埋点
          sessionStorage.setItem("pageType", page_type);
          // return "关闭提示";
        };
      });
    },
    list() {
      this.$api
        .advertisingList({
          advertisingPosition: "2"
        })
        .then(res => {
          this.listObj = res.data.body;
        });
    },
    onLoad() {
      this.q.page++;
      this.goods();
    },
    goods() {
      this.$api.goodsPaging(this.q).then(res => {
        this.items = this.items.concat(res.data.body);
        // 加载状态结束
        this.loading = false;
        // 数据全部加载完成
        if (res.data.body.length < 10) {
          this.finished = true;
        }
        this.items.forEach((item, index) => {
          this.$nextTick(() => {
            this.$trackFn.load("product_list" + index, "view_material", {
              // 曝光 - 埋点
              page_type: "profit",
              card_type: "product_list",
              card_position: index + 1,
              material_id: item.skuNo,
              material_type: "product_id",
              material_link: item.goodsDetailUrl,
              material_position: index + 1
            });
          });
        });
      });
    },
    urlFn(url) {
      window.location.href = url;
    },
    guizeFn() {
      this.$trackFn.send("click_material", {
        // 点击 - 埋点
        page_type: "profit",
        card_type: "promotion_rule",
        card_position: 1,
        material_type: "promotion_rule",
        material_position: 1,
        material_link:
          window.location.protocol +
          "//" +
          window.location.host +
          "/distribution/guize"
      });
      this.$router.push("/guize");
    },
    lianxi() {
      this.$trackFn.send("click_material", {
        // 点击 - 埋点
        page_type: "profit",
        card_type: "contact_service",
        card_position: 1,
        material_type: "contact_service",
        material_position: 1,
        material_link:
          window.location.protocol +
          "//" +
          window.location.host +
          "/distribution/call"
      });
      this.$router.push("/call");
    },
    log() {
      this.$router.push("/log");
      this.$trackFn.send("click_material", {
        page_type: "profit",
        card_type: "bargain",
        sell_type:"retailstore",
                  sell_label:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'goodsid_yljkapp_yygw':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'goodsid_ydbapp_sy':"goodsid_wx_off",
                  sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
        material_type:"bargain",
        material_link:`${window.location.origin}/log`
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.user,.fun{
  background: #fff;
  border-radius: 16px;
  padding: 30px;
  margin-bottom: 30px;
  .line1{
    display: inline-flex;
    margin-top: -0.7rem;
    .avatar{
      width: 120px;
      height: 120px;
      border-radius:50%;
      box-shadow: 0px 8px 12px 0px rgba(0, 0, 0, 0.1);
      border: 3px solid #FFFFFF;
      margin-right: 30px;
      img{
        border-radius:50%;
      }
    }
    .name{
      font-size: 36px;
      font-weight: 500;
      color: #333333;
      line-height: 1;
      padding-top: 0.8rem;
      font-family: PingFangSC-Medium, PingFang SC;
    }
  }
  .line2{
    margin: 0.4rem 0;
    background: #F8F8F8;
    border-radius: 8px;
    text-align: center;
    padding: 30px 0;
    .totalAmount{
        font-size: 60px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #333333;
        padding-bottom: 0.2rem;
        line-height: 1;
    }
  }
  .line3{
    .num{
      font-size: 36px;
      font-family: DINAlternate-Bold, DINAlternate;
      font-weight: bold;
      color: #333333;
    }
    .text{
      color: #888888;
      font-size: 24px;
    }
    img{
      width: 24px;
    }
  }
  .fun_ico{
    width: 80px;
    margin: auto;
  }
  .text{
    font-size: 22px;
  }
}
.contx {
  overflow: hidden;
}

.kong1 {
  padding-top: 80px;
  text-align: center;
}

.kong1 img {
  width: 270px;
}

.kong1 p {
  font-size: 24px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 34px;
}

.list {
  width: calc(50% - 15px);
  background: rgba(255, 255, 255, 1);
  border-radius: 12px;
  float: left;
  margin-bottom: 30px;
  overflow: hidden;
}

.img1 {
  height: 168px;
  border-radius: 12px;
}

.list:nth-child(odd) {
  margin-right: 30px;
}

.list:nth-child(even) {
  margin-right: 0;
}

.vip {
  // width: 72px;
  height: 32px;
  padding: 0 20px;
  margin-left: 20px;
  margin-top: 0.8rem;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  // background: url("../img/vip.png") no-repeat center;
  // background-size: 100% 100%;

background: linear-gradient(104deg, #FFA500 0%, #FF8800 100%);
border-radius: 140px 116px 116px 0px;
  color: #fff;
  box-sizing: border-box;
}

.good_list {
  width: 100%;
  height: 280px;
  display: block;
}

.goods_text_p {
  text-align: justify;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  font-size: 28px;
  color: #404040;
  -webkit-box-orient: vertical;
  height: 84px;
}

.goods_text_cont_x {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.tab {
  margin-bottom: 20px;
  margin-top: 20px;
  display: flex;
  align-items: baseline;
}

.tabDiv {
}

.goods_text_cont {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.goods_text {
  display: flex;
  align-items: center;
}

.goods_text_left {
  color: #FF5D5D;
  font-size: 20px;
  align-items: baseline;
}

.goods_text_right {
  color: #ffa72e;
  background: rgba(255, 167, 46, 0.09);
  border-radius: 30px;
  height: 28px;
  justify-content: left;
  position: relative;
  top: 3px;
  padding: 4px 8px;
}

.goods_text_right img {
  width: 22px;
  height: 22px;
}

.goods_text_right span {
  font-size: 20px;
}

.goods_text_left span {
  font-size: 36px;
}

.tabs {
  display: flex;
}

.tab_list {
  padding-right: 80px;
}

.tab_list p {
  color: #999;
}

.tab_list:last-child {
  padding-right: 20px;
}

.tab_list p {
  font-size: 30px;
  padding: 24px 0;
}

.tab_list_act .line {
  width: 60px;
  height: 4px;
  background: rgba(221, 43, 30, 1);
  border-radius: 2px;
  display: block;
}

.tab_list_act .tab_color {
  color: rgba(221, 43, 30, 1);
}

.imgx {
  height: 168px;
}

.tab_color {
  color: #404040 !important;
}

.header_flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
  padding-top: 20px;
}

.header_flex_left {
  display: flex;
  align-items: center;
}

.header_flex_left img {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  margin-right: 30px;
}

.header_flex_left p {
  font-size: 30px;
  color: #404040;
}

.header_flex_left .header_flex_left_p {
  font-size: 0.3rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  color: #404040;
  max-width: 2rem;
}

.header_flex_right {
  display: flex;
  align-items: center;
  justify-content: right;
}

.header_flex_right .button {
  width: 126px;
}

.header_flex_right .button:first-child {
  margin-right: 20px;
}

.jifen_cont {
  width: 100%;
  background: rgba(255, 255, 255, 1);
  border-radius: 12px;
  margin-bottom: 30px;
  text-align: center;
}

.jifen_cont_top h3 {
  padding-top: 40px;
  font-size: 60px;
  font-weight: 500;
  color: rgba(221, 43, 30, 1);
  line-height: 60px;
  padding-bottom: 14px;
}

.jifen_cont_top p {
  font-size: 24px;
  font-weight: 400;
  color: rgba(64, 64, 64, 1);
  line-height: 24px;
  padding-bottom: 40px;
  border-bottom: 1px solid #e6e6e6;
}

.jifen_cont_botton {
  display: flex;
  align-items: center;
  padding-top: 24px;
  padding-bottom: 24px;
}

.jifen_cont_botton div {
  width: 33.33%;
  border-left: 1px solid #e6e6e6;
}

.jifen_cont_botton div h3 {
  font-size: 36px;
  font-weight: bold;
  color: rgba(64, 64, 64, 1);
  line-height: 40px;
  margin-bottom: 18px;
}

.jifen_cont_botton div p {
  font-size: 24px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 24px;
}

.jifen_cont_botton div:first-child {
  border: none;
}

.dis {
  display: flex;
  align-items: center;
  justify-content: center;
}

.dis img {
  width: 24px;
  height: 24px;
}
</style>
